import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Divider, Steps } from 'antd';
import { FileOutlined, FileAddOutlined } from '@ant-design/icons';

import { exportActions } from '../../redux/actions';
import { downloadExportCsv } from '../../utils/csvExport';

import PageHeader from '../../components/PageHeader';
import SelectExportTemplate from '../../components/SelectExportTemplate';

const Export = () => {
    const dispatch = useDispatch();
    const exportingData = useSelector((state) => state.exporting.exporting);
    const exportData = useSelector((state) => state.exporting.exported);
    const organization = useSelector((state) => state.organization.organization);

    const [step, setStep] = useState(0);
    const [currentTemplate, setCurrentTemplate] = useState(null);
    const [finished, setFinished] = useState(false);

    const handleExportTemplate = () => {
         if (!currentTemplate) return;
      
         // currentTemplate is the saved config from the server
        const scenarioIds = (currentTemplate.export_entity || [])
            .filter(e => e.entity_type === 'scenario')
            .map(e => e.entity_id);

        const businessCaseIds = (currentTemplate.export_entity || [])
            .filter(e => e.entity_type === 'business')
            .map(e => e.entity_id);

        dispatch(exportActions.exportData({
            scenarioIds,
            businessCaseIds,
            resultBusinessCases: !!currentTemplate.result_business_cases,
            nonCalculatedOnly: !!currentTemplate.non_calculated_only,
        }));

        setFinished(true);
        };

    const handleDownloadCSV = (data) => {
        downloadExportCsv(data, organization, 'CSV Export File');
    };

    const renderStep = (stepCount) =>
        [<SelectExportTemplate currentTemplate={currentTemplate} setCurrentTemplate={setCurrentTemplate} />][stepCount];

    const goToPreviousStep = () => {
        setStep((_current) => _current - 1);
    };

    const goToNextStep = () => {
        setStep((_current) => _current + 1);
    };

    return (
        <>
            <PageHeader />
            <div
                style={{
                    padding: '0 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                }}
            >
                <div style={{ padding: 20 }}>
                    <Steps current={step}>
                        <Steps.Step title="Select" icon={<FileOutlined />} description={'Select a Template'} />
                        <Steps.Step title="Export" icon={<FileAddOutlined />} description={'Export data'} />
                    </Steps>
                </div>

                <Divider style={{ margin: 0, borderTopColor: 'rgba(0, 0, 0, 0.1)' }} />

                <div style={{ height: '50vh', overflow: 'auto' }}>{renderStep(step)}</div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 10,
                        marginTop: 30,
                    }}
                >
                    {!finished && !exportingData ? (
                        <>
                            <Button type="primary" onClick={goToPreviousStep}>
                                Back
                            </Button>
                            {step < 1 ? (
                                <Button type="primary" disabled={currentTemplate == null} onClick={goToNextStep}>
                                    {'Next'}
                                </Button>
                            ) : (
                                <Button type="primary" onClick={handleExportTemplate}>
                                    {'Finish Export'}
                                </Button>
                            )}
                        </>
                    ) : exportData != null ? (
                        <Button type="primary" onClick={() => handleDownloadCSV(exportData)}>
                            Download CSV
                        </Button>
                    ) : null}
                </div>
            </div>
        </>
    );
};

export default Export;
